import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import useBetsAccordion from 'features/sportHistory/model/useBetsAccordion';
import { selectSportHistoryLocale } from 'features/sportHistory/redux/selectors';
import SVG from 'components/SVG';
import arrowDownSVG from 'features/sportHistory/img/arrow-down.svg';
import arrowUpSVG from 'features/sportHistory/img/arrow-up.svg';
import userSVG from 'features/sportHistory/img/user.svg';

import BetItem from '../BetItem/BetItem';

import './SportHistoryItem.scss';

const b = block('sport-history-item');

const SportHistoryItem = ({ item }) => {
  const locale = useSelector(selectSportHistoryLocale);
  const model = useBetsAccordion(item.id);

  return (
    <div
      className={b({
        status: item.status,
      })}>
      <div className={b('coupon')}>
        <div className={b('value')}>{item.remoteCouponId}</div>
        <div className={b('role')}>
          <SVG
            containerClassName={b('user')}
            svgProps={{
              svg: userSVG,
            }}
          />
          <div className={b('value-col')}>
            <div className={b('value')}>{item.userId}</div>
            <div className={b('player')}>{item.username}</div>
          </div>
        </div>
        <div className={b('value')}>{item.createdAt}</div>
        <div className={b('value')}>{item.isExpress ? locale.type.express : locale.type.single}</div>
        <div className={b('value')}>{item.provider}</div>
        <div className={b('value')}>{item.amount}</div>
        <div className={b('value')}>{item.currency}</div>
        <div className={b('value')}>{item.coef}</div>
        <div className={b('value')}>{item.possibleWinAmount}</div>
        <div
          className={b('value', {
            status: item.status,
          })}>
          {locale.status?.[item.status] ?? item.status}
        </div>
        <button disabled={model.actionProcessing} onClick={model.handleClick} className={b('arrow')}>
          <SVG
            containerClassName={b('arrow-icon', {
              isOpen: !model.isOpen,
            })}
            svgProps={{
              svg: arrowDownSVG,
            }}
          />
          <SVG
            containerClassName={b('arrow-icon', {
              isOpen: model.isOpen,
            })}
            svgProps={{
              svg: arrowUpSVG,
            }}
          />
        </button>
      </div>
      <div className={b('bets', { isOpen: model.isOpen })}>
        {model.bets.map(bet => (
          <BetItem key={bet.id} item={bet} />
        ))}
      </div>
    </div>
  );
};

export default SportHistoryItem;
